"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadOneTrustScript = void 0;
const constants_1 = require("../../constants");
const loadOneTrustScript = (domainKey, scriptSource) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptSource;
    script.async = true;
    script.type = 'text/javascript';
    script.dataset.documentLanguage = 'true';
    script.dataset.domainScript = domainKey;
    script.onload = () => {
        resolve();
    };
    script.onerror = () => {
        reject(new Error(constants_1.ERROR_MESSAGES.LOADING_ONETRUST_SCRIPT));
    };
    document.head.insertBefore(script, document.head.firstElementChild);
});
exports.loadOneTrustScript = loadOneTrustScript;
//# sourceMappingURL=loadOneTrustScript.js.map